import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import eventify from 'Eventify';
import DateFormatted from '../DateFormatted';
import RCore from 'RCore';
const i18Common = require('../../../../i18/i18.Common');

const i18 = RCore.getTranslation.bind({ dict: i18Common });

const Table = styled.div`
    display: table-row-group;
    vertical-align: middle;
    border: none;
`;

const MatchCellHeader = styled.div`
    opacity: 0.9;
    padding: 10px 0;
    font-size: 18px;
    text-align: left;
    color: ${props => props.theme.primaryColor};
`;

const Cell = styled.div`
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
`;

const Score = styled.div`
    display: table-cell;
    color: ${props => (props.isLive ? props.theme.primaryTextColor : props.theme.color)};
    padding: 10px 0;
    font-size: 20px;

    .tv-info {
        margin-right: 30px;
        text-align: right;
        min-width: 90px;
    }

    .top-sub-score,
    .tmc-date {
        min-width: 80px;
        text-align: right;
    }
`;

const TeamNameBox = styled.div`
    display: table-cell;
    padding: 10px 40px 10px 0;
    width: 360px;
    font-size: 20px;

    .vs {
        padding: 0 10px;
    }
`;

const TeamName = styled.span`
    display: inline-block;
`;

class MatchCell extends React.Component {
    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object,
        screenSizeObserver: PropTypes.object,
        moment: PropTypes.func,
    };

    render() {
        let { event, lang } = this.props;
        event = eventify(event);

        const tvInfo = event.channel && event.channel.name && <div className="tv-info">{event.channel.name}</div>;
        const isToday = this.context.moment(event.startDate).isSame(new Date(), 'day');
        const isFinished = event.isFinished();
        const isComing = event.isComing();
        const isLive = event.isLive();

        return (
            <Cell>
                <TeamNameBox className="__c__c2_textCell">
                    <TeamName>{event.homeName}</TeamName>
                    <span className="vs">vs</span>
                    <TeamName>{event.awayName}</TeamName>
                </TeamNameBox>
                <Score isLive={isLive} className="__c__c1_textCell">
                    {isFinished && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div className="top-sub-score">{event.score.home + ' - ' + event.score.away}</div>
                        </div>
                    )}
                    {isLive && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {tvInfo}
                            <div className="top-sub-score">{event.score.home + ' - ' + event.score.away}</div>
                        </div>
                    )}
                    {event.isCancelled() && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {i18('status.short.cancelled', lang)}
                        </div>
                    )}
                    {event.isPostponed() && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {i18('status.short.postponed', lang)}
                        </div>
                    )}

                    {isComing &&
                        !event.isCancelled() &&
                        !event.isPostponed() &&
                        isToday && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                {tvInfo}
                                <DateFormatted className="tmc-date" date={event.startDate} type="TIME" el="div" />
                            </div>
                        )}
                    {isComing &&
                        !event.isCancelled() &&
                        !event.isPostponed() &&
                        !isToday && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <DateFormatted className="tmc-date" date={event.startDate} type="TIME" el="div" />
                            </div>
                        )}
                </Score>
            </Cell>
        );
    }
}

MatchCell.propTypes = {
    event: PropTypes.object.isRequired,
};

const Container = ({ children }) => <Table>{children}</Table>;

export default { MatchCellHeader, MatchCell, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/matchCell/TextMatchCell.js
 **/